import { gql } from "@apollo/client";

export const GET_HEADER_OPTIONS = gql`
query headerOptions {
  	mainMenu : menu(id: "Main Menu", idType: NAME) {
      menuItems(first: 1000) {
        nodes {
            id
            key: id
            parentId
            title: label
            url
            cssClasses
            path
            target
            menuItemNew{
              image
              content
              link
              useAbsolutePath
            }
            childItems {
              nodes {
                id
                parentId
                title : label
                url
                path
                target
                menuItemNew{
                  useAbsolutePath
                }
              }
            }
        }
      }
    }
    stoneleighButtonsMenu : menu(id: "Stoneleigh Button Menu", idType: NAME) {
      menuItems(first: 1000) {
        nodes {
            id
            key: id
            parentId
            title: label
            url
            cssClasses
            path
            target
            menuItemNew{
              image
              content
              link
            }
            childItems {
              nodes {
                id
                parentId
                title : label
                url
                path
                target
              }
            }
        }
      }
    }
    stoneleighMenu : menu(id: "Stoneleigh Menu", idType: NAME) {
      menuItems(first: 1000) {
        nodes {
            id
            key: id
            parentId
            title: label
            url
            cssClasses
            path
            target
            menuItemNew{
              image
              content
              link
              useAbsolutePath
            }
            childItems {
              nodes {
                id
                parentId
                title : label
                url
                path
                target
              }
            }
        }
      }
    }
  }
`;

export const GET_HOME_PAGE = gql`
  query homePage {
    pageBy(uri: "/") {
      databaseId
      uri
      title
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaRobotsNoindex
        metaRobotsNofollow
        metaKeywords
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
            altText
            sourceUrl
            srcSet
            mediaDetails{
              file
              filePath
              height
              width
            }
            mimeType
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        opengraphPublisher
        opengraphSiteName
        opengraphType
        twitterTitle
        twitterDescription
        twitterImage {
            altText
            sourceUrl
            srcSet
        }
        breadcrumbs {
            url
            text
        }
        cornerstone
        schema {
            pageType
            articleType
            raw
        }
        readingTime
      }
      home {
        heroContent
        heroSlides {
          image {
            sourceUrl
            altText
          } 
          caption
          photoCredit
        }
        threeColumnWidgetContent
        threeColumnWidget {
          image {
            sourceUrl
            altText
          }
          content
        }
        visitBackgroundImage {
          sourceUrl
          altText
        }
        visitBackgroundImageCaption
        visitContent
        visitButtons {
          button
        }
        visitTiles {
          image {
            sourceUrl
            altText
          }
          title
          link
        }
        volunteerImage {
          sourceUrl
          altText
        }
        volunteerContent
        upcomingEventsTitle
        newsImage {
          sourceUrl
          altText
        }
        newsContent
      }
    }
    posts(first: 4) {
      edges {
        node {
          databaseId
          title
          uri
        }
      }
    }
  }
`;

export const GET_404_DATA = gql`
query errorOptions {
    siteOptions {
      siteOptions {
        errorContent
      }
    }
  }
`;

export const GET_STONELEIGH_HOME = gql`
  query stoneleighHomePage {
    pageBy(uri: "stoneleigh") {
      databaseId
      uri
      title
      pageCallToAction {
        callToAction {
          ... on CallToAction {
            callToAction {
              backgroundImage {
                sourceUrl
              }
              content
              type
              buttons {
                button
              }
            }
          }
        }
      }
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaRobotsNoindex
        metaRobotsNofollow
        metaKeywords
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
            altText
            sourceUrl
            srcSet
            mediaDetails{
              file
              filePath
              height
              width
            }
            mimeType
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        opengraphPublisher
        opengraphSiteName
        opengraphType
        twitterTitle
        twitterDescription
        twitterImage {
            altText
            sourceUrl
            srcSet
        }
        breadcrumbs {
            url
            text
        }
        cornerstone
        schema {
            pageType
            articleType
            raw
        }
        readingTime
      }
      stoneleighHome {
        heroSlides {
          image {
            sourceUrl
            altText
          }
          caption
          photoCredit
        }
        threeColumnWidgetContent
        threeColumnWidget {
          image {
            sourceUrl
            altText
          }
          content
        }
        visitBackgroundImage {
          sourceUrl
          altText
        }
        visitBackgroundImageCaption
        visitContent
        visitTiles {
          image {
            sourceUrl
            altText
          }
          title
          link
          openInANewTab
        }
        volunteerImage {
          sourceUrl
          altText
        }
        volunteerContent
        upcomingEventsTitle
        newsImage {
          sourceUrl
          altText
        }
        newsContent
      }
    }
    posts(first: 4, where: {categoryId: 466}) {
      edges {
        node {
          databaseId
          title
          uri
        }
      }
    }
  }
`;

export const GET_PAGE = gql`
  query pageBuilder($slug: String) {
    pageBy(uri: $slug) {
      databaseId
      uri
      title
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaRobotsNoindex
        metaRobotsNofollow
        metaKeywords
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
            altText
            sourceUrl
            srcSet
            mediaDetails{
              file
              filePath
              height
              width
            }
            mimeType
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        opengraphPublisher
        opengraphSiteName
        opengraphType
        twitterTitle
        twitterDescription
        twitterImage {
            altText
            sourceUrl
            srcSet
        }
        breadcrumbs {
            url
            text
        }
        cornerstone
        schema {
            pageType
            articleType
            raw
        }
        readingTime
      }
      template {
        templateName
      }
      pageCallToAction {
        callToAction {
          ... on CallToAction {
            callToAction {
              backgroundImage {
                sourceUrl
              }
              content
              type
              buttons {
                button
              }
            }
          }
        }
      }
      stoneleighPageBuilder{
        hideSubnavigationButtons
      }
      pageBuilder {
        triggerBlackbaudFormOnLoad
        hideNavigation
        navigationButton
        contentRows{
          type 
          content
          headerBackgroundColor
          splitHeaderBackgroundColor
          backgroundColor
          backgroundImage{
            sourceUrl
          }
          image {
            sourceUrl
            altText
            caption
            description
            mediaDetails {
                sizes {
                    sourceUrl
                    height
                    width
                }
            }
          }
          gallery {
            src: sourceUrl
            alt: caption,
            caption: caption
            description: description
          }
          twoColumnWidgets{
            image{
              altText
              sourceUrl
              caption
            }
            content
            button
          }
          threeColumnWidgets{
            image{
              altText
              sourceUrl
              caption
            }
            content
            button
          }
          fourColumnWidgets{
            image{
              altText
              sourceUrl
              caption
            }
            content
            button
          }
          accordions{
            title
            content
          }
          eventTitle
          eventCategory {
            databaseId
          }
          featuredEvent {
            ... on Event {
              databaseId
              title
              date
              excerpt
              uri
              startDate
              endDate
              allDay
              venue {
                city
                state
                title
                url
              }
              featuredImage{
                node{
                  sourceUrl
                  title
                  altText
                }
              }
              terms {
                nodes {
                  name
                  ... on NewsPreserve {
                    databaseId
                    name
                  }
                }
              }
            }
          }
          featuredNews {
            ... on Post {
              databaseId
              title
              date
              excerpt
              uri
              featuredImage{
                node{
                  sourceUrl
                  altText
                  title
                  srcSet
                  sizes
                  mediaDetails{
                    sizes{
                      height
                      width
                      sourceUrl
                    }
                  }
                }
              }
            }
          }
          threeLogos {
            logo{
              sourceUrl
              altText
              title
              srcSet
              sizes
              mediaDetails{
                sizes{
                  height
                  width
                  sourceUrl
                }
              }
            }
            link
          }
          fourLogos {
            logo{
              sourceUrl
              altText
              title
              srcSet
              sizes
              mediaDetails{
                sizes{
                  height
                  width
                  sourceUrl
                }
              }
            }
            link
          }
          fiveLogos {
            logo{
              sourceUrl
              altText
              title
              srcSet
              sizes
              mediaDetails{
                sizes{
                  height
                  width
                  sourceUrl
                }
              }
            }
            link
          }
          sixLogos {
            logo{
              sourceUrl
              altText
              title
              srcSet
              sizes
              mediaDetails{
                sizes{
                  height
                  width
                  sourceUrl
                }
              }
            }
            link
          }
          buttons{
            button
          }
          form
        }
      }
    }
  }
`;

export const GET_PRESERVE = gql`
  query preserve($slug: String){
    preservesBy(slug: $slug) {
      databaseId
      title
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaRobotsNoindex
        metaRobotsNofollow
        metaKeywords
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
            altText
            sourceUrl
            srcSet
            mediaDetails{
              file
              filePath
              height
              width
            }
            mimeType
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        opengraphPublisher
        opengraphSiteName
        opengraphType
        twitterTitle
        twitterDescription
        twitterImage {
            altText
            sourceUrl
            srcSet
        }
        breadcrumbs {
            url
            text
        }
        cornerstone
        schema {
            pageType
            articleType
            raw
        }
        readingTime
      }
      featuredImage{
        node{
          sourceUrl
        }
      }
      preserveFeatures {
        nodes{
          databaseId
          name
          preserveFeature{
            icon{
              sourceUrl
            }
          }
        }
      }
      preserves {
        acreage
        alertBarContent
        alertBarLink
        description
        displayAlertBar
        headerContent
        galleryBackgroundImage{
          sourceUrl
        }
        galleryContent
        imageCaption
        location
        physicalAddress
        trailMap
        visitorHours
        galleryContent
        gallery {
          src: sourceUrl
          alt: altText
          caption
          description
        }
        galleryCaption
        admissionPrice
        accordionContent
        accordions {
          title
          content
        }
      }
    }
  }
`;

export const GET_PLANT_OPTIONS = gql`
  query plantOptions {	
    siteOptions{
      plantOptions{
        plantHeaderContent
        plantCta {
          ... on CallToAction {
            callToAction {
              backgroundImage {
                sourceUrl
              }
              content
              type
              buttons {
                button
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_PLANT_ATTRIBUTES = gql`
  query plantAttributes {
    allPlantAttribute {
      nodes {
        databaseId
        slug
        name
      }
    }
  }
`;

export const GET_PLANT_TYPES = gql`
  query plantTypes {
    allPlantTypes {
      nodes {
        databaseId
        slug
        name
      }
    }
  }
`;

export const SEARCH_PLANTS = gql`
    query staffPosts(
      $search: String
    ){
      seo {
          contentTypes {
            plants {
              archive {
                title
                metaDesc
                metaRobotsNoindex
                metaRobotsNofollow
              }
            }
          }
        }
    }
  `;

export const GET_PLANTS = gql`
  query plantList {
    seo {
      contentTypes {
        plants {
          archive {
            title
            metaDesc
            metaRobotsNoindex
            metaRobotsNofollow
          }
        }
      }
    }
  }
`;

export const GET_PLANT = gql`
  query plant($slug: String){
    plantsBy(slug: $slug) {
      databaseId
      title
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaRobotsNoindex
        metaRobotsNofollow
        metaKeywords
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
            altText
            sourceUrl
            srcSet
            mediaDetails{
              file
              filePath
              height
              width
            }
            mimeType
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        opengraphPublisher
        opengraphSiteName
        opengraphType
        twitterTitle
        twitterDescription
        twitterImage {
            altText
            sourceUrl
            srcSet
        }
        breadcrumbs {
            url
            text
        }
        cornerstone
        schema {
            pageType
            articleType
            raw
        }
        readingTime
      }
      featuredImage{
        node{
          sourceUrl
          mediaDetails{
            sizes {
              file
              fileSize
              height
              mimeType
              name
              sourceUrl
              width
            }
          }
          caption
        }
      }
      plants {
        scientificName
        details
      }
      plantTypes{
        nodes{
          name
          slug
        }
      }
      plantAttribute{
        nodes{
          name
          slug
        }
      }
    }
  }
`;

export const GET_NEWS_PRESERVES = gql`
  query newsPreserves($slug: [String]){
    newsPreserves(where: {slug: $slug}) {
      edges {
        node {
          posts {
            nodes {
              databaseId
              date
              excerpt
              featuredImage{
                node{
                  altText
                  srcSet
                  sizes
                  sourceUrl
                  title
                  mediaDetails{
                    width 
                    height
                  }
                }
              }
              title
              uri
            }
          }
        }
      }
    }
  }
`;

export const GET_PRESERVE_CATEGORIES = gql`
  query preserveCategories{
    preserveCategories{
      nodes{
        databaseId,
        uri,
        name,
        slug
      }
    }
  }
`;

export const GET_PRESERVES_LANDING_PAGE = gql`
  query preservesLandingPage {
    seo {
      contentTypes {
        preserves {
          archive {
            title: breadcrumbTitle
            metaDesc
            metaRobotsNoindex
            metaRobotsNofollow
          }
        }
      }
    }
    allPreserves(first: 1000, where: {orderby: {field: TITLE, order: ASC}}) {
      nodes{
        databaseId
        title
        uri 
        featuredImage {
          node {
            sourceUrl
            title
            sizes
            altText
            mediaDetails {
              width
              height
            }
            srcSet
          }
        }
        preserves{
          acreage
          location
          redirectLink
        }
      }
    }
    siteOptions{
      preservesLandingPage{
        headerContent
        leftContent
        rightImage{
          id
          altText
          srcSet
          title
          sourceUrl
          sizes
          mediaDetails{
            width
            height
            sizes {
              file
              fileSize
              height
              mimeType
              name
              sourceUrl
              width
            }
          }
        }
        rightImageCaption
        cta: callToAction {
          ... on CallToAction {
            callToAction {
              backgroundImage {
                sourceUrl
              }
              content
              buttons {
                button
              }
            }
          }
        }
        widgets{
          content
          image{
            id
            altText
            srcSet
            title
            sourceUrl
            sizes
            mediaDetails{
              width
              height
              sizes {
                file
                fileSize
                height
                mimeType
                name
                sourceUrl
                width
              }
            }
          }
        }
      }
    } 
  }
`;

export const GET_PRESERVE_BY_CATEGORY = gql`
  query preserveByCategory($slug: [String]) {
    preserveCategories(where: {slug: $slug}) {
      nodes {
        databaseId
        uri
        name
        preserves(first: 200) {
          nodes{
            databaseId
            title
            uri 
            featuredImage {
              node {
                sourceUrl
                title
                sizes
                altText
                mediaDetails {
                  width
                  height
                }
                srcSet
              }
            }
            preserves{
              acreage
              location
              redirectLink
            }
          }
        }
      }
    }
  }
`;

export const GET_NEWS_DATA = gql`
  query newsPost($slug: String){
    postBy(slug: $slug) {
      databaseId
      title
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaRobotsNoindex
        metaRobotsNofollow
        metaKeywords
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
          mediaDetails{
            file
            filePath
            height
            width
          }
          mimeType
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        opengraphPublisher
        opengraphSiteName
        opengraphType
        twitterTitle
        twitterDescription
        twitterImage {
            altText
            sourceUrl
            srcSet
        }
        breadcrumbs {
            url
            text
        }
        cornerstone
        schema {
            pageType
            articleType
            raw
        }
        readingTime
      }
      date
      content
      featuredImage {
        node {
          sourceUrl
          title
          sizes
          altText
          caption
          description
          mediaDetails {
            width
            height
          }
          srcSet
        }
      }
    }
  }
`;

export const GET_NEWS_POSTS = gql`
    query newsPosts(
        $first: Int
        $last: Int
        $after: String
        $before: String
    ) {
    seo {
      contentTypes {
        post {
          archive {
            title
            metaDesc
            metaRobotsNoindex
            metaRobotsNofollow
          }
        }
      }
    }
    posts(first: $first, last: $last, after: $after, before: $before) {
    	pageInfo{
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
        total
      }
      edges{
        cursor
        node{
          id
          databaseId
          title
          uri
          date
          excerpt
          searchExcerpt{
            excerpt
          }
          categories{
            edges{
              node{
              	uri
                name
              }
            }
          }
          featuredImage {
            node {
              id
              altText
              srcSet
              title
              sourceUrl
              sizes
              description
              caption
              mediaDetails {
                width
                height
                sizes(include: _1060_680_IMAGE_SIZE) {
                  sourceUrl
                }
              }
            }
          }
        }
      }
    }
}`;

export const GET_CATEGORY_POSTS = gql`
    query categoryPosts(
        $first: Int
        $last: Int
        $after: String
        $before: String,
        $category: String,
    ) {
    categories(where: {slug: [$category]}) {
        edges {
            node {
                id
                name
                posts(first: $first, last: $last, after: $after, before: $before) {
                    pageInfo {
                    hasNextPage
                    hasPreviousPage
                    startCursor
                    endCursor
                    }
                    edges {
                    cursor
                    node {
                        id
                        databaseId
                        title
                        uri
                        date
                        excerpt
                        categories {
                          edges {
                            node {
                              id
                              uri
                              name
                            }
                          }
                        }
                        searchExcerpt{
                          excerpt
                        }
                        featuredImage {
                          node {
                            id
                            altText
                            srcSet
                            title
                            sourceUrl
                            sizes
                            description
                            caption
                            mediaDetails {
                              width
                              height
                              sizes(include: _1060_680_IMAGE_SIZE) {
                                sourceUrl
                              }
                            }
                          }
                        }
                    }
                    }
                }
            }
        }
    }
  }`;

export const GET_CATEGORIES = gql `
  query getCategories {
    categories(first: 1000, where: {hideEmpty: true}) {
      nodes {
        name
        uri
        slug
      }
    }
  }
`;

export const GET_STAFF_MENU = gql`
  query staffMenu {
    menu(id: "Staff Menu", idType: NAME) {
      menuItems {
        edges {
          node {
            id
            url
            label
            path
          }
        }
      }
    }
  }
`;

export const GET_STAFF_PAGE = gql`
  query staffPageData {
    pageBy(pageId: 14) {
      databaseId
      uri
      title
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaRobotsNoindex
        metaRobotsNofollow
        metaKeywords
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
          mediaDetails{
            file
            filePath
            height
            width
          }
          mimeType
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        opengraphPublisher
        opengraphSiteName
        opengraphType
        twitterTitle
        twitterDescription
        twitterImage {
            altText
            sourceUrl
            srcSet
        }
        breadcrumbs {
            url
            text
        }
        cornerstone
        schema {
            pageType
            articleType
            raw
        }
        readingTime
      }
      staffandLeadership{
        headerContent
        image{
            id
            altText
            srcSet
            title
            sourceUrl
            sizes
            mediaDetails{
              width
              height
              sizes {
                file
                fileSize
                height
                mimeType
                name
                sourceUrl
                width
              }
            }
        }
        imageCaption
        staffTitle
        staffMembers{
          ... on Staff{
            featuredImage{
              node{
                id
                altText
                srcSet
                title
                sourceUrl
                sizes
                mediaDetails{
                  width
                  height
                  sizes {
                    file
                    fileSize
                    height
                    mimeType
                    name
                    sourceUrl
                    width
                  }
                }
              }
            }
            uri
            title
            staff{
              title
            }
          }
        }
        cta: callToAction {
              ... on CallToAction {
                callToAction {
                  backgroundImage {
                    sourceUrl
                  }
                  content
                  buttons {
                    button
                  }
                }
              }
            }
      }
    }
  }
`;

export const GET_STAFF_ALTERNATE_DATA = gql`
  query staffPageData ($slug: String){
    pageBy(uri: $slug) {
      databaseId
      title
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaRobotsNoindex
        metaRobotsNofollow
        metaKeywords
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
          mediaDetails{
            file
            filePath
            height
            width
          }
          mimeType
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        opengraphPublisher
        opengraphSiteName
        opengraphType
        twitterTitle
        twitterDescription
        twitterImage {
            altText
            sourceUrl
            srcSet
        }
        breadcrumbs {
            url
            text
        }
        cornerstone
        schema {
            pageType
            articleType
            raw
        }
        readingTime
      }
      staffAlternate {
        headerContent
        image{
          id
          altText
          srcSet
          title
          sourceUrl
          sizes
          mediaDetails{
            width
            height
            sizes {
              file
              fileSize
              height
              mimeType
              name
              sourceUrl
              width
            }
          }
        }
        imageCaption
        title
        singleColumnContent
        twoColumnContent{
          content
        }
        cta: callToAction {
            ... on CallToAction {
              callToAction {
                backgroundImage {
                  sourceUrl
                }
                content
                buttons {
                  button
                }
              }
            }
          }
      }
    }
  }
`;

export const GET_STAFF_DATA = gql`
  query staff($slug: String){
    staffBy(slug: $slug) {
      databaseId
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaRobotsNoindex
        metaRobotsNofollow
        metaKeywords
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
            altText
            sourceUrl
            srcSet
            mediaDetails{
              file
              filePath
              height
              width
            }
            mimeType
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        opengraphPublisher
        opengraphSiteName
        opengraphType
        twitterTitle
        twitterDescription
        twitterImage {
            altText
            sourceUrl
            srcSet
        }
        breadcrumbs {
            url
            text
        }
        cornerstone
        schema {
            pageType
            articleType
            raw
        }
        readingTime
      }
      featuredImage {
        node {
          sourceUrl
          title
          sizes
          altText
          mediaDetails {
            width
            height
          }
          srcSet
        }
      }
      title
      staff{
        biography
        title
      }
    }
  }
`;

export const GET_FOOTER_OPTIONS = gql`
  query footerOptions {
    siteOptions {
      siteOptions {
        address
        mobileAddress
        facebookLink
        instagramLink
        linkedinLink
        tiktokLink
        youtubeLink
        disclaimer
        logos {
          logo {
            sourceUrl
          }
          link
        }
        stoneleighAddress
        stoneleighFacebookUrl
        stoneleighInstagramUrl
        stoneleighForm
        stoneleighLogos{
          logo {
            sourceUrl
          }
          link
        }
        form
        copyrightContent
        headerContent
        cta: newsCallToAction {
          ... on CallToAction {
            callToAction {
              backgroundImage {
                sourceUrl
              }
              content
              buttons {
                button
              }
            }
          }
        }
        errorContent
        formUrl
      }
    }
    menu(id: "Footer Menu", idType: NAME) {
      menuItems {
        edges {
          node {
            id
            url
            label
            path
          }
        }
      }
    }
  }
`;

export const GET_REDIRECTS = gql `
  query getRedirects {
    redirection{
      redirects{
        origin
        target
        type
        code
      }
    }
  }
`;

export const GET_PAGE_SEO = gql `
  query getPageSEO($slug: String) {
    pageBy(uri: $slug) {
      pageSeo{
        noindex
      }
    }
  }
`;